// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3l2ch","label":"Category_label__3T9hC","content":"Category_content__yzv60","header":"Category_header__1AT1M","location":"Category_location__3pB5R"};